import { render, staticRenderFns } from "./Material-icon.vue?vue&type=template&id=4a013eee"
import script from "./Material-icon.vue?vue&type=script&lang=js"
export * from "./Material-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports